// extracted by mini-css-extract-plugin
export var chevronIcon = "_9n-2";
export var teamName = "_9n-1";
export var teamSwitcherButton = "_9n-0";